import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(
  ({ palette, shadows, spacing, breakpoints }) => ({
    "drawer-wrapper": {
      zIndex: 999,
    },

    drawer: {
      backgroundColor: "white",
      bottom: 0,
      boxShadow: shadows[10],
      display: "flex",
      flexDirection: "column",
      left: 0,
      position: "fixed",
      top: 0,
      width: spacing(8),
      transition: "width 200ms",
      zIndex: 1,

      [breakpoints.down("sm")]: {
        width: 0,
      },
    },

    "drawer--dangerous": {
      bottom: 30,
    },

    "drawer--expanded": {
      width: spacing(32),
    },

    drawer__footer: { flexGrow: 0 },

    drawer__header: {
      alignItems: "center",
      backgroundColor: palette.primary.main,
      display: "flex",
      flexGrow: 0,
      height: spacing(8),
      justifyContent: "flex-start",
      padding: spacing(0, 1.5),
      minWidth: spacing(8),
      overflow: "hidden",
    },

    drawer__header_icon: { color: palette.background.paper },

    drawer__header_logo: { color: palette.background.paper, cursor: "pointer" },

    drawer__list: {
      flexGrow: 1,
      height: 0,
      overflowX: "hidden",
      overflowY: "auto",
    },

    drawer__time: {
      "& > div": {
        backgroundColor: palette.default.light,
      },
      overflow: "hidden",
      flexGrow: 0,
    },

    version: {
      color: palette.common.white,
      fontSize: 10,
    },

    overlay: {
      "$drawer--expanded + &": {
        [breakpoints.down("lg")]: {
          visibility: "visible",
          opacity: 1,
        },
      },

      content: '""',
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0, 0, 0, .2)",
      visibility: "hidden",
      opacity: 0,
      transition: "opacity 200ms",
    },
  }),
);
